import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type { Notification, GlobalErrorHandler } from '..'

export class NotificationApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  getNotifications = () => {
    return this.fetchInstance
      .get(ApiEndpoints.NOTIFICATIONS)
      .then((data) =>
        data.notifications.map((obj: { notification: Notification }) => obj.notification),
      )
      .finally()
  }

  updateNotification = (notification: Notification) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.NOTIFICATIONS}/${notification.guid}`, {
        guid: notification.guid,
        has_been_viewed: notification.has_been_viewed,
      })
      .then((data) => data.notification)
      .finally()
  }

  // Note: The notifications/mark_all_as_viewed endpoint is broken, but still returns 202.
  // A bug ticket has been filed to fix it, but should not require any changes here.
  markAllAsViewed = (channel?: number) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.NOTIFICATIONS}/mark_all_as_viewed`, { channel })
      .finally()
  }
}
